import {useGetCreditHistoryMutation} from '../../../../../services/cellcast.v3'
import {GetCurrentData} from '../../../../Utils/_helpers/GetCurrentData'
import {defaultRegion} from '../../../../../_metronic/helpers'
import {useDispatch, useSelector} from 'react-redux'
import {stopLoading, startLoadding} from '../../../../Redux/FrontEnd/Loading/LoadingSlice'
import {CreditHistory, getAllUserCreditHistory} from '../Overview/OverviewSlice/UserDetailsSlice'

export function useBalanceHistory() {
  const dispatch = useDispatch()
  const currentUser = GetCurrentData()

  const userCreditHistory: any = useSelector(getAllUserCreditHistory)

  const [getCreditHistory, {data: creditHistory}] = useGetCreditHistoryMutation()

  const fetchBalanceHistory = (params?: any) => {
    if (currentUser?.region === defaultRegion) {
      dispatch(CreditHistory(params))
    } else {
      dispatch(startLoadding())
      getCreditHistory({
        action: 'find_credit_history',
        data: {
          ...params,
          isAsOwner: params?.isAsOwner === 'true',
          size: parseInt(params?.size ?? 10),
        },
      })
      dispatch(stopLoading())
    }
  }

  return {
    fetchBalanceHistory,
    userCreditHistory:
      currentUser?.region === defaultRegion ? userCreditHistory : creditHistory?.data,
  }
}
